import { dateFormat } from '../commons/DateUtils'
import { numberFormat } from '../commons/NumberUtils'

/**
 * BOM UTF-8. Sem ele o Excel abre o arquivo como ANSI e os acentos viram
 * caracteres inválidos.
 */
export const UTF8_BOM = '﻿'

/**
 * Separador ponto e vírgula porque os números saem formatados em pt-BR
 * (`1.234,56`). Com vírgula, cada decimal quebraria em duas células.
 */
export const CSV_SEPARATOR = ';'

export const CSV_COLUMNS = [
    'Número do pedido',
    'Data do pedido',
    'Vendedor',
    'Cliente',
    'Produto',
    'Peso (ton)',
    'Classificação',
    'Valor total',
    'Urgente',
]

/** Escape RFC 4180: só quando o valor contém aspas, o separador ou quebra de linha. */
export const escapeCsvValue = value => {
    const text = value === null || value === undefined ? '' : String(value)

    const needsQuotes =
        text.includes('"') ||
        text.includes(CSV_SEPARATOR) ||
        text.includes('\n') ||
        text.includes('\r')

    if (!needsQuotes) return text

    return `"${text.replace(/"/g, '""')}"`
}

/**
 * Uma linha por item do pedido, com os dados do pedido repetidos.
 *
 * ⚠️ "Valor total" é o total DO PEDIDO e se repete em cada linha dele. Somar a
 * coluna direto no Excel superconta pedidos com mais de um produto — a
 * ressalva está registrada em docs/business/relatorio-detalhado-de-pedidos.md.
 */
export const buildDetailedOrderReportCsv = (orders = []) => {
    const lines = [CSV_COLUMNS.join(CSV_SEPARATOR)]

    orders.forEach(order => {
        const items = order.items?.length ? order.items : [{}]

        items.forEach(item => {
            const row = [
                order.number,
                dateFormat(order.integrationDate),
                order.sellerName,
                order.clientName,
                item.productName,
                numberFormat(item.weightInTonnes ?? 0, 2),
                item.classificationName,
                numberFormat(order.totalValue ?? 0, 2),
                order.isUrgent ? 'Sim' : 'Não',
            ]

            lines.push(row.map(escapeCsvValue).join(CSV_SEPARATOR))
        })
    })

    return lines.join('\r\n')
}

export const buildDetailedOrderReportFileName = ({ dateFrom, dateTo }) =>
    `relatorio-detalhado-pedidos_${dateFrom}_a_${dateTo}.csv`

export const downloadCsv = (fileName, csvContent) => {
    const blob = new Blob([UTF8_BOM + csvContent], {
        type: 'text/csv;charset=utf-8;',
    })

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.setAttribute('href', url)
    link.setAttribute('download', fileName)
    link.style.visibility = 'hidden'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(url)
}

export const exportDetailedOrderReportToCsv = (orders, period) => {
    const csvContent = buildDetailedOrderReportCsv(orders)

    downloadCsv(buildDetailedOrderReportFileName(period), csvContent)

    return csvContent
}
